import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableModule as PrTableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { PaginatorModule } from 'primeng/paginator';
import { DialogModule } from 'primeng/dialog';
import { ToolbarComponent, InfoBlockComponent, MoreMenuComponent } from '@src/app/components';
import { CaptionPipe } from '@src/app/pipes';
import { SkeletonRowTextComponent } from '@src/app/modules/skeleton-wrapper';

import { TableComponent } from './table.component';
import { CaptionComponent } from './components/caption/caption.component';
import { RowMenuComponent } from './components/row-menu/row-menu.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { ColumnsSettingDialog } from './components/columns-setting';
import { LoadingTimerComponent } from './components/loading-timer';

@NgModule({
  declarations: [TableComponent, CaptionComponent, RowMenuComponent, ConfirmDialogComponent, DialogComponent],
  imports: [
    ButtonModule,
    CommonModule,
    MenuModule,
    PaginatorModule,
    PrTableModule,
    DialogModule,
    ToolbarComponent,
    CaptionPipe,
    InfoBlockComponent,
    MoreMenuComponent,
    ColumnsSettingDialog,
    SkeletonRowTextComponent,
    LoadingTimerComponent,
  ],
  exports: [TableComponent],
})
export class TableModule {}
